import requestRaw from '@/utils/requestRaw'
import requestUpload from '@/utils/requestUpload'
import requestDownload from '@/utils/requestDownload'
import { APICoreV2 } from '@/utils/servicesApi'

function ticketRequest(config) {
  return requestRaw({
    ...config,
    silent: true
  })
}

export function getTicketList(params) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/list',
    method: 'GET',
    params
  })
}

export function getTicketDetail(params) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/detail',
    method: 'GET',
    params
  })
}

export function createTicket(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/create',
    method: 'POST',
    data
  })
}

export function updateTicket(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/update',
    method: 'POST',
    data
  })
}

export function updateTicketStatus(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/update-status',
    method: 'POST',
    data
  })
}

export function assignTicketAgent(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/assign-agent',
    method: 'POST',
    data
  })
}

export function addTicketNote(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/add-note',
    method: 'POST',
    data
  })
}

export function getTicketActivity(params) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/activity',
    method: 'GET',
    params
  })
}

export function getTicketStatistics() {
  return ticketRequest({
    url: APICoreV2() + '/ticket/statistics',
    method: 'GET'
  })
}

export function getTicketAgents(params) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/agents',
    method: 'GET',
    params
  })
}

// Kanban: satu request per status (cursor pagination per kolom).
export function getTicketKanban(params) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/kanban',
    method: 'GET',
    params
  })
}

// Reorder / move memakai anchor tiket, bukan posisi mentah.
export function reorderTicketKanban(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/kanban/reorder',
    method: 'POST',
    data
  })
}

export function bulkUpdateTickets(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/bulk-update',
    method: 'POST',
    data
  })
}

export function getTicketFollowUp(params) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/follow-up',
    method: 'GET',
    params
  })
}

export function scheduleTicketFollowUp(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/follow-up/schedule',
    method: 'POST',
    data
  })
}

export function bulkScheduleTicketFollowUp(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/follow-up/bulk-schedule',
    method: 'POST',
    data
  })
}

export function cancelTicketFollowUp(data) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/follow-up/cancel',
    method: 'POST',
    data
  })
}

// --- Lampiran gambar -------------------------------------------------------
// Upload memakai requestUpload agar browser menambahkan boundary multipart
// sendiri; jangan set Content-Type manual.

export function uploadTicketAttachments(ticketId, files, onProgress) {
  const formData = new FormData()
  formData.append('ticket_id', ticketId)
  Array.from(files || []).forEach(file => {
    formData.append('images[]', file)
  })

  return requestUpload({
    url: APICoreV2() + '/ticket/attachment/upload',
    method: 'POST',
    data: formData,
    onUploadProgress: event => {
      if (typeof onProgress !== 'function') return
      const total = Number(event && event.total)
      const loaded = Number(event && event.loaded)
      if (!total || total <= 0) return
      const percent = Math.min(100, Math.max(0, Math.round((loaded / total) * 100)))
      onProgress(percent)
    }
  })
}

export function getTicketAttachments(ticketId) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/attachment/list',
    method: 'GET',
    params: { ticket_id: ticketId }
  })
}

// Endpoint download mengembalikan 302 ke presigned URL. Response disimpan
// sebagai blob agar tetap melalui authenticated API client.
export function downloadTicketAttachment(id) {
  return requestDownload({
    url: APICoreV2() + '/ticket/attachment/download',
    method: 'GET',
    params: { id },
    responseType: 'blob'
  })
}

export function deleteTicketAttachment(id) {
  return ticketRequest({
    url: APICoreV2() + '/ticket/attachment/delete',
    method: 'POST',
    data: { id }
  })
}



// WEBPACK FOOTER //
// ./src/api/ticket.js